import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {TimezoneSource} from 'common/src/modules/timezones/timezones.types';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {ScheduleCardScratchpadState} from '../../scratchpad/scheduleCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const setTimezoneSourceInputSchema = z.object({
  timezoneSource: z
    .nativeEnum(TimezoneSource)
    .describe('The timezone source (Manual, User, or Advertiser)'),
});

export default function setTimezoneSourceTool() {
  async function execute(
    params: ToolExecuteParams<typeof setTimezoneSourceInputSchema, ScheduleCardScratchpadState>,
  ) {
    const {timezoneSource} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<ScheduleCardScratchpadState>(
      agentScratchpad,
      NodeType.SCHEDULE,
    );

    validatedScratchpad.card.timezoneSource = timezoneSource;

    return toolResult(`Timezone source set to ${timezoneSource}`);
  }

  return tool<typeof setTimezoneSourceInputSchema, ScheduleCardScratchpadState>({
    name: V2CardAgentToolName.SetTimezoneSource,
    displayName: 'Setting timezone source',
    description: 'Set where the schedule timezone comes from.',
    inputSchema: setTimezoneSourceInputSchema,
    execute,
  });
}
